import * as React from "react";
import { _MasterDetailView, } from "../generic/master-detail-view/MasterDetailView";
import { DetailViewStoreItems } from "./DetailViewStoreItems";
import { MasterViewStoreItems } from "./MasterViewStoreItems";
export var TabStoreItems = function () {
    var MasterDetailView = _MasterDetailView;
    return (React.createElement(MasterDetailView, { masterRenderer: MasterViewStoreItems, detailRenderer: DetailViewStoreItems }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/store/TabStoreItems.tsx
// module id = 2756
// module chunks = 3